import FirstSection from "./firstsection";
import FourthSection from "./fourthsection";
import HeaderSection from "./header";
import RentalInfo from "./rentalinfo";
import SecondSection from "./secondsection";
import ThirdSection from "./thirdsection";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { getLocalization } from "../../redux/localization";
import { useLocation } from "react-router-dom";
import { appUrl } from "../../redux/base/types/url";
import images from "../../assets/images";
import { languagesSelector } from "../../redux/languages";

const Homepage = () => {
  const location = useLocation();
  const t = useSelector(getLocalization);
  const title = t.getString("HomeSeoTitle");
  const desc = t.getString("HomeSeoDescription");

  const languages = useSelector(languagesSelector);
  return (
    <div className="">
      <Helmet>
        {/* <link rel="alternate" hrefLang="x-default" href={appUrl} />
        {languages.map((x) => {
          let code = x.Code.split("-")[0];
          return (
            <link
              rel={code === "en" ? "canonical" : "alternate"}
              hrefLang={code}
              href={appUrl + "/" + code}
            />
          );
        })} */}
        <title>Smart Car Rental Software for Modern Fleets | Rentificial</title>
<meta name="description" content="Manage your fleet with Rentificial – the smart car rental software built for flexibility, growth, and efficiency. Start free, no credit card required." />
<meta name="keywords" content="car rental software, fleet management, vehicle rental system, rent software, online car booking, rental automation" />
<link rel="canonical" href="https://www.rentificial.com/" />

       
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={desc} />
        <meta name="twitter:image" content={title} />
        <meta name="twitter:card" content={"large_summary_card"} />
        <meta name="twitter:site" content="@rentificial" />
        <meta name="twitter:creator" content="@rentificial" />
        <meta property="og:title" content={title} />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={desc} />
        <meta property="og:image" content={images.logoColored} />
        <meta property="og:url" content={appUrl  + location.pathname} />
      </Helmet>
      <HeaderSection />
      <RentalInfo />
      <FirstSection />
      <SecondSection />
      <ThirdSection />
      <FourthSection />
      {/* <UygunaKiralaAd /> */}
    </div>
  );
};
export default Homepage;
